export class NapkinIDESolution {

}
